import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { TeamStoreEffects } from './team-store.effects';
import { reducer, teamStoreFeatureKey } from './team-store.reducers';

export function provideTeamStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(teamStoreFeatureKey, reducer),
    provideEffects([TeamStoreEffects]),
  ]);
}
